import {apiUrl} from "../utils/constants";
import {GET, POST} from "./api.service.wrapper";


export const GetVehicles = async (args) => {
    const response = await GET(apiUrl.vehicles, args);
    return response;
}